import {Elements} from "@stripe/react-stripe-js"
import {Stripe, loadStripe, StripeElementsOptions, StripeElementsOptionsClientSecret} from "@stripe/stripe-js"
import {useQuery} from "@tanstack/react-query"
import {Spin} from "antd"
import {handleError} from "helpers"
import {usePaymentProviderConfigs} from "hooks/usePaymentProviderConfigs"
import React, {useEffect, useMemo, useRef, useState} from "react"
import {studentPaymentService} from "services"
import {PaymentProvider} from "types/student-account/student-payment"

const StripeElementsProvider: React.FC<
    React.PropsWithChildren<{profileId: number; loadKey?: string | number; options?: StripeElementsOptionsClientSecret}>
> = ({children, profileId, loadKey = "default", options}) => {
    const {paymentProviderConfigs} = usePaymentProviderConfigs()

    const stripePromise = useMemo(() => {
        for (const config of paymentProviderConfigs) {
            if (config.provider === PaymentProvider.Stripe) {
                return loadStripe(config.publishableKey)
            }
        }
        return undefined
    }, [paymentProviderConfigs])

    const clientSecretQuery = useQuery({
        queryKey: ["stripe-client-secret", profileId, loadKey],
        queryFn: async () => {
            return await studentPaymentService.stripeCreateSetupIntent(profileId)
        },
        enabled: !!profileId,
        refetchOnWindowFocus: false
    })

    if (!stripePromise || !clientSecretQuery.data) {
        return <Spin />
    }

    return (
        <Elements stripe={stripePromise} options={{...options, clientSecret: clientSecretQuery.data}}>
            {children}
        </Elements>
    )
}

export default StripeElementsProvider
